import { Box, Typography } from "@mui/material";

/**
 * Componente que muestra un mensaje de error
 */
const ErrorMessage = ({ content }) => {
  return (
    <Box>
      <Typography variant="body2" color="error">
        {content}
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
